module.exports = __webpack_public_path__ + "static/media/Forschung.8eef3569.png";